import Modal from "../../layouts/Modal";
import { IHiddenPage } from "../../models/HiddenPages";
import HiddenPageSingle from "./HiddenPageSingle";

export default function HiddenPageModal({
  open,
  setOpen,
  hiddenPage,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  hiddenPage?: IHiddenPage;
}) {
  return (
    <Modal width="max-w-4xl" open={open} setOpen={setOpen}>
      <h1 className="text-xl">{hiddenPage ? "Edit Hidden Page" : "Add Hidden Page"}</h1>

      <div className="mt-4">
        <div className="space-y-4 border-t border-gray-200">
          <div className="pt-4 grid grid-cols-1 gap-x-4 gap-y-4 sm:gap-y-6 sm:grid-cols-1">
            <HiddenPageSingle hiddenPage={hiddenPage} onSuccess={() => setOpen(false)} />
          </div>
        </div>
      </div>
    </Modal>
  );
}
